import $ from "jquery";
import {useRef} from "react";

interface BannerContentInterface {
    banner: object;
}

// Redimensionne la partie "message" lorsque la bannière est chargée
function resizeHeader() {
    const header = $('#layout-header')
    const info = $('#layout-header .info')
    const infoContent = $(header).find('.content')
    const banner = $('#layout-header img.banner')

    if (window.innerWidth > 992) {
        const height = Math.round($(banner).innerHeight())
        $(header).css('max-height', Math.round(height))
        $(info).css('max-height', Math.round(height))
        $(infoContent).css('max-height', Math.round(height - 60)) // Pour éviter que l'overflow ne déborde
    } else {
        $(header).css('height', '')
    }
}

export function BannerContent({banner}: Readonly<BannerContentInterface>) {
    const bannerLink = useRef(undefined)

    function handleDownload(url: string) {
        bannerLink.current.href = url

        if (url.endsWith('.pdf')) {
            const urlInformations = url.split('/')
            const fileName = urlInformations.at(-1);
            bannerLink.current.setAttribute('download', fileName)
        }
    }

    return (
        <>
            {banner.urlBandeau ? (
                <a
                    ref={bannerLink}
                    target={'_blank'}
                    rel={'noreferrer'}
                    onClick={() => handleDownload(banner.urlBandeau)}>
                    <img
                        className="banner img-fluid"
                        src={banner.fichier}
                        alt={banner.fichier}
                        onLoad={resizeHeader}
                    />
                </a>
            ) : (
                <img
                    className="banner img-fluid"
                    src={banner.fichier}
                    alt={banner.fichier}
                    onLoad={resizeHeader}
                />
            )}
        </>
    )
}